import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import TableLoader from '../../Shared/TableOrder/TableOrder';
import Order from './Order';
import API from '../../../api';
import './OrderList.css';

const OrderList = () => {
    const [orders, setOrders] = useState([]);
    const [isUpdated, setIsUpdated] = useState(false);

    useEffect(() => {
        API.get('/orders')
            .then(res => setOrders(res.data))
            .catch(err => console.log(err));
    }, [isUpdated]);

    const handleAction = (id, status) => {
        setIsUpdated(true);

        API.patch(`/statusUpdate/${id}`, { status: status })
            .then(res => {
                if (res.data) {
                    setIsUpdated(false);
                }
            })
            .catch(err => {
                console.log(err);
                setIsUpdated(false);
            });
    };

    return (
        <div className="px-2">
            {
                orders.length === 0 ?
                    <TableLoader />
                    :
                    <div className="orderList">
                        <Table hover>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email ID</th>
                                    <th>Service</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {
                                    orders.map(order => (
                                        <Order
                                            key={order._id}
                                            order={order}
                                            handleAction={handleAction}
                                        />
                                    ))
                                }
                            </tbody>
                        </Table>
                    </div>
            }
        </div>
    );
};

export default OrderList;